<template>
    <nav
        class="flex flex-wrap items-center gap-1 border-b border-border"
        aria-label="Billing sections"
    >
        <button
            v-for="tab in tabs"
            :key="tab.key"
            type="button"
            class="flex min-h-10 shrink-0 items-center gap-2 border-b-2 px-4 py-3 text-sm whitespace-nowrap transition-colors"
            :class="
                active === tab.key
                    ? 'border-new-topol-blue bg-surface-card text-foreground dark:bg-muted'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
            "
            @click="navigate(tab)"
        >
            {{ tab.label }}
        </button>
    </nav>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';

type BillingTabKey = 'subscription' | 'invoices';

const props = defineProps({
    active: {
        type: String as PropType<BillingTabKey>,
        required: true,
    },
});

const tabs: Array<{ key: BillingTabKey; label: string; routeName: string }> = [
    { key: 'subscription', label: 'Subscription', routeName: 'billing.plugin-subscriptions.index' },
    { key: 'invoices', label: 'Invoices', routeName: 'billing.invoices.index' },
];

const navigate = (tab: { key: BillingTabKey; routeName: string }): void => {
    if (tab.key === props.active) return;
    router.get(route(tab.routeName));
};
</script>
